import { MeteringService } from '@qdrant/qdrant-cloud-public-api/metering/v1';
import {
  getUsageBreakdown,
  listMonthlyMeterings,
  listMeterings,
} from '@qdrant/qdrant-cloud-public-api/metering/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';

export const meteringService = createServiceQueries(MeteringService, {
  listMeteringsQuery: (params) => queryOptions(listMeterings, params, { transport, select: (d) => d.items }),
  listMonthlyMeteringsQuery: (params) =>
    queryOptions(listMonthlyMeterings, params, { transport, select: (d) => d.items }),
  // `prices/evaluate` (Orb) runs slow (median ~4.5s, p95 ~15s per Orb support) so this query gets
  // a longer 30s deadline than the transport-wide 10s default (which was cancelling loads that
  // would otherwise have succeeded). It also retries the same errors the app default retries
  // (`queryRetryHandler`), but 3 times with exponential backoff (1s, 2s, 4s).
  getUsageBreakdownQuery: (params) => ({
    ...queryOptions(getUsageBreakdown, params, { transport, timeoutMs: 30_000, select: (d) => d.items }),
    retry: 3,
    retryDelay: (attempt: number) => Math.min(1_000 * 2 ** attempt, 4_000),
  }),
});
